import { Button, ButtonRow, FormSection, Text } from '@ksyos/design-system';
import { formatString } from '@common/utils/formatString';
import { getDisplayName } from '@common/utils/getDisplayName';
import { getSelectedLanguage } from '@frontend/translate';
import { useAccountRequestContext } from '@frontend/utils/hooks/useAccountRequestContext';
import { AccountRequestReviewByOrganizationView } from './AccountRequestReviewByOrganizationViews';

interface AccountRequestReviewingViewProps {
    handleViewChange: (newView: AccountRequestReviewByOrganizationView) => void;
}

export function AccountRequestReviewingView(props: Readonly<AccountRequestReviewingViewProps>) {
    const translate = getSelectedLanguage();
    const { accountRequest, approveAccountRequest } = useAccountRequestContext();

    return (
        <>
            <FormSection isBorderless>
                <Text textAlign="center">
                    {formatString(translate.accountRequest.introPageTextPartOne, [
                        getDisplayName(accountRequest.requestedByPractitioner),
                    ])}
                    <b> {getDisplayName(accountRequest.userData.practitioner)} </b>
                    {formatString(translate.accountRequest.introPageTextPartTwo, [
                        translate.professionEnum[accountRequest.userData.employment.profession],
                        accountRequest.organization.name,
                    ])}
                </Text>
            </FormSection>
            <FormSection
                isBorderless
                sx={{ marginTop: [11, 14] }}
            >
                <ButtonRow>
                    <Button
                        color="success"
                        iconLeft="closed"
                        onClick={async () => {
                            await handleApprove();
                        }}
                        width="full"
                    >
                        {translate.accountRequest.approve}
                    </Button>
                    <Button
                        color="danger"
                        iconLeft="close"
                        onClick={() => props.handleViewChange(AccountRequestReviewByOrganizationView.rejectingRequest)}
                        width="full"
                    >
                        {translate.common.decline}
                    </Button>
                </ButtonRow>
            </FormSection>
        </>
    );

    async function handleApprove() {
        await approveAccountRequest();

        props.handleViewChange(AccountRequestReviewByOrganizationView.requestApproved);
    }
}
